
import React from 'react';

const ColorBlindFilters: React.FC = () => {
  return (
    <svg className="absolute -z-50 w-0 h-0" aria-hidden="true" focusable="false">
      <defs>
        {/* Filtre pour la protanopie (difficulté à voir le rouge) */}
        <filter id="protanopia-filter">
          <feColorMatrix
            in="SourceGraphic"
            type="matrix"
            values="0.567, 0.433, 0,     0, 0
                    0.558, 0.442, 0,     0, 0
                    0,     0.242, 0.758, 0, 0
                    0,     0,     0,     1, 0"
          />
        </filter>
        
        {/* Filtre pour la deutéranopie (difficulté à voir le vert) */}
        <filter id="deuteranopia-filter">
          <feColorMatrix
            in="SourceGraphic"
            type="matrix"
            values="0.625, 0.375, 0,   0, 0
                    0.7,   0.3,   0,   0, 0
                    0,     0.3,   0.7, 0, 0
                    0,     0,     0,   1, 0"
          />
        </filter>
        
        {/* Filtre pour la tritanopie (difficulté à voir le bleu) */}
        <filter id="tritanopia-filter">
          <feColorMatrix
            in="SourceGraphic"
            type="matrix"
            values="0.95, 0.05,  0,     0, 0
                    0,    0.433, 0.567, 0, 0
                    0,    0.475, 0.525, 0, 0
                    0,    0,     0,     1, 0"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default ColorBlindFilters;
